import React from "react";

const Articles = () => {
  return <div>All articles</div>;
};

export default Articles;
